import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const PIECES = [
    {
        n: "01",
        kicker: "Territoire",
        title: ["Une côte que ", { em: "peu" }],
        title2: ["de monde ", { em: "connaît" }, "."],
        lead: "Entre Ault et Le Tréport, un littoral de craie resté intime — des villas classées, une forêt royale, un train direct depuis Paris.",
        image: "hero_cliffs_cinematic.jpg",
        to: "/magazine/cote-nouvelle-destination-chic",
    },
    {
        n: "02",
        kicker: "Dossier",
        title: ["Le verre ", { em: "de" }],
        title2: ["Blangy."],
        lead: "Depuis 1506, la vallée de la Bresle souffle 75 % des flacons de parfumerie du monde. Le Musée du Verre raconte ce savoir-faire unique.",
        image: "xp_atelier_parfum.jpg",
        to: "/experiences/musee-du-verre-blangy",
    },
    {
        n: "03",
        kicker: "Rituel",
        title: ["Les ", { em: "trains" }],
        title2: ["qu'on reprend."],
        lead: "De Paris-Nord à Mers-les-Bains en 2h19. Un geste ancien qu'on redécouvre.",
        image: "hero_train_mers_1902_v2.jpg",
        to: "/manifeste",
    },
];

const renderTitle = (parts) => parts.map((p, i) => (
    typeof p === "string" ? <span key={i}>{p}</span> :
    <em key={i} className="cp-display-italic text-cp-foret">{p.em}</em>
));

export default function NouvelleVague() {
    return (
        <section className="py-24 md:py-40 bg-cp-ivoire cp-grain" data-testid="nouvelle-vague">
            <div className="max-w-[1600px] mx-auto px-6 md:px-12">
                {/* Header */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20 md:mb-24">
                    <div className="md:col-span-4">
                        <p className="cp-tiny text-cp-terre mb-5">La Nouvelle Vague</p>
                        <h2 className="cp-serif text-[56px] md:text-[92px] leading-[0.9] tracking-[-0.03em] text-cp-encre">
                            Ce qu'on <em className="cp-display-italic text-cp-terre">dit</em><br />
                            de cette côte.
                        </h2>
                    </div>
                    <p className="md:col-span-6 md:col-start-7 cp-serif italic text-xl md:text-3xl font-light text-cp-gris leading-[1.4] self-end">
                        Pas un guide. Un mouvement. Trois textes qui racontent <em>pourquoi</em> ce morceau de côte retient l'attention — et pourquoi il mérite qu'on prenne le temps.
                    </p>
                </div>

                {/* Three pieces */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10 lg:gap-16">
                    {PIECES.map((p, i) => (
                        <motion.div
                            key={p.n}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                        >
                            <Link
                                to={p.to}
                                data-testid={`vague-piece-${p.n}`}
                                className="group block"
                            >
                                <div className="cp-image-zoom aspect-[4/5] bg-cp-craie mb-8">
                                    <img
                                        src={`${BACKEND}/api/static/img/${p.image}`}
                                        alt=""
                                        loading="lazy"
                                        className="w-full h-full object-cover cp-photo-warm"
                                    />
                                </div>
                                <div className="flex items-baseline gap-4 mb-4">
                                    <span className="cp-serif italic text-3xl text-cp-terre">{p.n}</span>
                                    <span className="cp-tiny text-cp-sable-deep">{p.kicker}</span>
                                </div>
                                <h3 className="cp-serif text-4xl md:text-5xl leading-[0.95] tracking-[-0.02em] text-cp-encre mb-5 group-hover:text-cp-terre transition-colors">
                                    {renderTitle(p.title)}<br />
                                    {renderTitle(p.title2)}
                                </h3>
                                <p className="cp-serif italic text-lg text-cp-gris leading-snug max-w-md">
                                    {p.lead}
                                </p>
                                <span className="cp-tiny text-cp-terre mt-5 inline-block border-b border-cp-terre opacity-0 group-hover:opacity-100 transition-opacity">
                                    Lire →
                                </span>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
